// import { RequestServiceGet } from "./services-mia/RequestServiceGet";

// export const getUserCredentials = async () => {

    // if (
    //     localStorage.getItem("hooliToken") &&
    //     localStorage.getItem("sessionId")
    // ) {
    //     return {
    //         hooliToken: localStorage.getItem("hooliToken"),
    //         sessionId: localStorage.getItem("sessionId"),
    //         merchantId: localStorage.getItem("merchantId"),
    //         merchantRZ: localStorage.getItem("merchantRZ"),
    //         merchantNombre: localStorage.getItem("merchantNombre"),
    //         merchantCUIT: localStorage.getItem("merchantCUIT"),
    //     };
    // }

    // return null;

//     let userCredentials;
//     try {
//         userCredentials = await RequestServiceGet({
//             service: "TemporalSession",
//             params: {
//                 merchantId: 26,
//                 usuarioId: 5625,
//             },
//         });
//     } catch (err) {
//         console.log(`Error: ${err}`);
//     }

//     if (!userCredentials || !(userCredentials?.length > 0)) {
//         console.log(`Fetch failed`);
//     }

//     sessionStorage.setItem("hooliToken", userCredentials[0].hooliToken);
//     sessionStorage.setItem("sessionId", userCredentials[0].sessionId);
//     sessionStorage.setItem("merchantId", 7);
//     sessionStorage.setItem("merchantRZ", "Rio Negro");
//     sessionStorage.setItem("merchantNombre", "Rio Negro");
//     sessionStorage.setItem("merchantCUIT", "30-71512361-2");

//     const newCredentials = {
//         ...userCredentials[0],
//         merchantId: 7,
//         merchantRZ: "Rio Negro",
//         merchantNombre: "Rio Negro",
//         merchantCUIT: "30-71512361-2",
//     };

//     return newCredentials;
// };

import { RequestServiceGet } from "./services-mia/RequestServiceGet";

export const getUserCredentials = async () => {
  if (
    localStorage.getItem("hooliToken") &&
    localStorage.getItem("sessionId")
  ) {
    return {
      hooliToken: localStorage.getItem("hooliToken"),
      sessionId: localStorage.getItem("sessionId"),
      merchantId: localStorage.getItem("merchantId"),
      merchantRZ: localStorage.getItem("merchantRZ"),
      merchantNombre: localStorage.getItem("merchantNombre"),
      merchantCUIT: localStorage.getItem("merchantCUIT"),
    };
  }
  const allowTemporal = 
    process.env.REACT_APP_ALLOW_TEMPORAL_SESSION
  if (allowTemporal) {
    console.log("ALLOW_TEMPORAL_SESSION is  true");
    let userCredentials;
    try {
      userCredentials = await RequestServiceGet({
        service: "TemporalSession",
        params: {
          merchantId: 26,
          usuarioId: 5767,
          // merchantId: 1,
          // usuarioId: 0,
        },
      });
    } catch (err) {
      console.log(`Error: ${err}`);
    }
    if (!userCredentials || !(userCredentials?.length > 0)) {
      console.log(`Fetch failed`);
    }
    localStorage.setItem("hooliToken", userCredentials[0].hooliToken);
    localStorage.setItem("sessionId", userCredentials[0].sessionId);
    localStorage.setItem("merchantId", 26);
    localStorage.setItem("merchantRZ", "Sistema de Salud Rio Negro");
    localStorage.setItem("merchantNombre", "Sistema de Salud Rio Negro");
    localStorage.setItem("merchantCUIT", "30-71512361-2");

    const credentials = {
      hooliToken: userCredentials[0].hooliToken,
      sessionId: userCredentials[0].sessionId,
      merchantId: 26,
      merchantRZ: "Sistema de Salud Rio Negro",
      merchantNombre: "Sistema de Salud Rio Negro",
      merchantCUIT: "30-71512361-2",
    };
    return credentials;
  }
  return null;
};
